export default __webpack_public_path__ + "static/media/ev_evse_error.3a4e86f6.svg";